import { render, staticRenderFns } from "./ReportsCommissionsPartner.vue?vue&type=template&id=4069085b&scoped=true&"
import script from "./ReportsCommissionsPartner.vue?vue&type=script&lang=js&"
export * from "./ReportsCommissionsPartner.vue?vue&type=script&lang=js&"
import style0 from "./ReportsCommissionsPartner.vue?vue&type=style&index=0&id=4069085b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4069085b",
  null
  
)

export default component.exports